<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <sidebar></sidebar>

    <div class="ant-table sites-table users-table">
      <div class="user">
        <a-descriptions title="User Info">
          <a-descriptions-item label="Name">
            {{user.name}}
          </a-descriptions-item>
          <a-descriptions-item label="Email">
            {{user.email}}
          </a-descriptions-item>
          <a-descriptions-item label="Phone">
            {{user.phone}}
          </a-descriptions-item>
        </a-descriptions>
      </div>

      <h2>Sites <span class="sites-count">{{user.sites.length}}</span></h2>
      <table>
        <thead class="ant-table-thead">
        <tr>
          <th>Name</th>
          <th>Slug</th>
          <th>Email</th>
          <th>Status</th>
          <th>Is VIP</th>
          <th>Subscribed</th>
        </tr>
        </thead>

        <tbody class="ant-table-tbody">
        <tr v-if="user.sites.length" class="ant-table-row" v-for="site in user.sites" :key="site.id">
          <td>
            <router-link :to="{name:'sites.overview',params:{siteId:site.id}}">
              {{ site.name }}
            </router-link>
          </td>
          <td>{{ site.slug }}</td>
          <td>{{ site.email }}</td>
          <td>
            <div v-if="! site.data_deletion">
              <span class="text-success" v-if="site.api_token">Connected</span>
              <span class="text-warning" v-if="! site.api_token">Not Connected</span>
            </div>
            <div @mouseover="showCancelDelete = true" @mouseleave="showCancelDelete = false" class="deletion-area" v-else>
              <div v-if="site.data_deletion.value.status == 'pending'" class="text-danger">
                <div class="text-danger">
                  Requested to delete
                  <a-button v-if="showCancelDelete" type="danger" @click="cancelDelete(site.id)" icon="delete" />
                </div>
                <div class="text-gray">{{dateFormat(site.data_deletion.value.request_at)}}</div>
              </div>
              <div v-if="site.data_deletion.value.status == 'approved'" class="text-danger">
                <div class="text-danger">Mark for deletion</div>
                <div class="text-warning">{{dateFormat(addDate(site.data_deletion.value.request_at, 30))}}</div>
              </div>
            </div>
          </td>
          <td>
            <span v-if="site.is_vip_site" class="text-success">Yes</span>
            <span v-else class="text-gray">No</span>
          </td>
          <td>
            <span v-if="site.is_premium" class="text-success">Yes</span>
            <span v-else class="text-gray">No</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </a-layout>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Api from "@/services/Api";
import sites from "../../../store/modules/sites";
import moment from "moment";
export default {
  name: "Details",
  computed: {
    sites() {
      return sites
    }
  },
  components: {
    Sidebar
  },
  data() {
    return {
      loading: false,
      user: {
        sites: []
      },
      showCancelDelete: false
    };
  },
  mounted() {
    this.fetchUser();
  },
  methods: {
    fetchUser() {
      this.loading = true;
      Api.get(`wemail/site-users/${this.$route.params.userId}`)
        .then(response => {
          console.log(response.data.data)
          this.user = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.$notification.error({
            message: "Error",
            description: error.response.data.message
          });
          this.loading = false;
        });
    },
    dateFormat(date) {
      return moment(date).fromNow();
    },
    addDate(date, days) {
      return moment(date).add(days, 'days').format('YYYY-MM-DD');
    }
  }
}
</script>

<style scoped>
.sites-table tbody.ant-table-tbody > tr > td,
.sites-table thead.ant-table-thead > tr > th {
  border-bottom: 2px solid #ededf4;
}
tbody.ant-table-tbody > tr > td {
  padding: 10px 16px;
}

.sites-table .ant-table-tbody {
  background: #fff;
}

.sites-table.ant-table {
  margin-bottom: 30px;
}

.sites-table {
  margin: 2.5%;
  width: 100%;
}

.sites-count {
  font-size: 20px;
  color: #999;
  font-weight: 400;
  margin-left: 10px;
}
.text-success {
  color: #52c41a;
}
.text-warning {
  color: #faad14;
}
.text-danger {
  color: #f5222d;
}
.text-gray {
  color: #999;
}
.user {
  width: 100%;
  margin-bottom: 2%;
  background-color: #fff;
  padding: 1%;
}
</style>